import apiClient from "../api/axiosConfig";
import { ENDPOINTS } from "../api/endpoints";
import {
  ApiResponse,
  LoginRequest,
  LoginResponse,
  RoleResponse,
  UserResponse,
} from "../../types/api.types";
import { LoginFormData } from "../../components/LoginForm";

export const roleService = {
  getRoles: async (): Promise<RoleResponse[]> => {
    const response = await apiClient.get<ApiResponse<RoleResponse[]>>(
      ENDPOINTS.USERS.GET_ROLES
    );
    return response.data.data;
  },
};
